export default __webpack_public_path__ + "static/media/logo-desktop-nav-efefef.9e043d37.svg";